<img
	class="logo"
	alt="Pantera Software Logo"
	[src]="logo() || 'assets/pms-logo.svg'"
/>
